import BASE from "./modules/base"
import AGENT from "./modules/agent";

export default {
    ...BASE,
    ...AGENT,
};
